import axios from 'axios'

export default {
  // 쿠폰 목록 불러오기
  // 쿠폰등록
  addCoupon (data, cb) {
    axios.post('/biz/pricing/coupon/register/', data)
      .then((response) => {
        cb(response)
      })
      .catch((e) => {
        const errorResponse = {error: true, data: e.response.data}
        cb(errorResponse)
      })
  },

  // 쿠폰 목록 불러오기
  getCouponInventory (cb) {
    axios.get('/biz/pricing/coupon-inventory/')
      .then((response) => {
        cb(response)
      })
      .catch((e) => {
        e.error = true
        cb(e)
      })
  },

  // 쿠폰 사용하기
  useCoupon (data, cb) {
    axios.post('biz/pricing/coupon-inventory/use/', data)
      .then((response) => {
        cb(response)
      })
      .catch((e) => {
        e.error = true
        cb(e)
      })
  }
}



// WEBPACK FOOTER //
// ./src/api/coupon.js